<script setup>
const emit = defineEmits(['click']);

const { t } = useI18n();
const searchStore = useSearchStore();

// stations
const departureLocationName = computed(
  () => searchStore.filters.departureStation?.name,
);
const arrivalLocationName = computed(
  () => searchStore.filters.arrivalStation?.name,
);

// date
const dateDisplay = computed(() => {
  const { roundTrip, departureDate, returnDate } = searchStore.filters;

  const result = [departureDate];

  if (roundTrip && returnDate) {
    result.push(returnDate);
  }

  return result;
});

// seats
const adultAmount = computed(() => searchStore.filters.adults);
const childAmount = computed(() => searchStore.filters.children?.length);
</script>

<template>
  <div class="blocks-form-header">
    <div class="blocks-form-header__wrapper">
      <div
        v-if="departureLocationName && arrivalLocationName"
        class="blocks-form-header__stations"
      >
        <span
          class="blocks-form-header__font blocks-form-header__font--stations"
        >
          {{ departureLocationName }} - {{ arrivalLocationName }}
        </span>
      </div>

      <div class="blocks-form-header__details">
        <UiDateDisplay
          v-if="dateDisplay"
          :date="dateDisplay"
          size="s"
          icon-size="s"
          theme="black"
          :with-paddings="false"
        />

        <div class="blocks-form-header__seat">
          <CIcon
            class="blocks-form-header__icon blocks-form-header__icon--adult"
            name="user"
          />

          <span class="blocks-form-header__font blocks-form-header__font--seat">
            {{ adultAmount }}
          </span>
        </div>

        <div v-if="childAmount > 0" class="blocks-form-header__seat">
          <CIcon class="blocks-form-header__icon" name="child" />

          <span class="blocks-form-header__font blocks-form-header__font--seat">
            {{ childAmount }}
          </span>
        </div>
      </div>
    </div>

    <UiButton
      class="blocks-form-header__button"
      type="button"
      theme="secondary"
      @click="emit('click')"
    >
      <span class="blocks-form-header__font blocks-form-header__font--button">
        {{ t('common.modify') }}
      </span>
    </UiButton>
  </div>
</template>
